import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: 'MOV', label: 'Movimentação' },
			{ value: 'RESUP', label: 'Ressuprimento' },
			{ value: 'INV', label: 'Inventário' },
			{ value: 'BLOQ', label: 'Bloqueio' },
			{ value: 'UNPICK', label: 'Unpick' }
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}
